import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import bgImage from "../../assets/images/backgrounds/main-slider-v2-1.jpg";
import bgImageTwo from "../../assets/images/backgrounds/main-slider-v2-2.jpg";
import bgImageThree from "../../assets/images/backgrounds/main-slider-v2-3.jpg";

import callBoxImg from "../../assets/images/resources/features-v2-call-box-img.jpg";

import AboutBackground from "../../assets/images/backgrounds/about-v2-bg.png";
import AboutSectionImage from "../../assets/images/about/about-v2-img1.jpg";
import AboutSectionLogo from "../../assets/images/resources/about-v2-logo.png";
import AboutSectionBoxImage from "../../assets/images/about/about-v2-img2.jpg";
import AboutSecRightLogo from "../../assets/images/resources/sec-title-icon1.png";

import ServiceOneSecImage from "../../assets/images/resources/sec-title-icon1.png";
import firstServiceImage from "../../assets/images/services/services-v1-img1.jpg";
import secondServiceImage from "../../assets/images/services/services-v1-img2.jpg";
import thirdServiceImage from "../../assets/images/services/services-v1-img3.jpg";
import fourthServiceImage from "../../assets/images/services/services-v1-img4.jpg";

import SectionSeperatorImage from "../../assets/images/resources/cta-two-1-1.png";

import ProjectSecLogo from "../../assets/images/resources/features-3-1-1.jpg";
import ProjectSecTitleIcon from "../../assets/images/resources/sec-title-icon1.png";

import FaqIconContent from "../../assets/images/resources/sec-title-icon2.png";
import FaqImage from "../../assets/images/resources/faq-1-1.png";

import ProjectSecIcon from "../../assets/images/resources/sec-title-icon1.png";
import firstProjectImage from "../../assets/images/project/projects-v2-img1.jpg";
import secondProjectImage from "../../assets/images/project/projects-v2-img2.jpg";
import thirdProjectImage from "../../assets/images/project/projects-v2-img3.jpg";
import fourProjectImage from "../../assets/images/project/projects-v2-img1.jpg";
import ProjectOneImage from "../../assets/images/project/projects-v2-img2.jpg";
import ProjectTwoImage from "../../assets/images/project/projects-v2-img3.jpg";

import StorySectionOne from "../../assets/images/resources/story-v1-img.jpg";
import StorySectionTwo from "../../assets/images/backgrounds/story-v1-bg.png";
import StorySectionIcon from "../../assets/images/resources/sec-title-icon1.png";

function Home() {
  const changeActiveFaq = (event) => {
    let allAccordionFaq = document.querySelectorAll(".accrodion");
    allAccordionFaq.forEach((item) => {
      item.classList.remove("active");
    });
    let clickedElem = event.target.closest(".accrodion");
    clickedElem.classList.add("active");
  };
  return (
    <>
      <section className="main-slider main-slider-one main-slider-one--two">
        <Swiper
          modules={[Autoplay, Navigation, Pagination, EffectFade]}
          slidesPerView={1}
          loop={true}
          effect="fade"
          autoplay={{ delay: 7000 }}
          pagination={{ clickable: true }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          className="thm-swiper__slider"
        >
          {[bgImage, bgImageTwo, bgImageThree].map((image, index) => (
            <SwiperSlide key={index}>
              <div
                className="image-layer"
                style={{ backgroundImage: `url(${image})` }}
              ></div>
              <div className="image-layer-overlay"></div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="main-slider-inner text-center">
                      <div className="main-slider__content">
                        <span className="main-slider-tagline">
                          We’re producing natural goods
                        </span>
                        <h2 className="main-slider__title">
                          Agriculture <span>&</span>
                          <br />
                          Organic Products
                        </h2>
                      </div>
                      <div className="main-slider__button-box">
                        <a href="#" className="thm-btn">
                          Discover more
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}

          {/* Navigation Buttons */}
          <div className="main-slider__nav">
            <div className="swiper-button-prev">
              <span className="icon-right-arrow-2"></span>
            </div>
            <div className="swiper-button-next">
              <span className="icon-right-arrow-2"></span>
            </div>
          </div>
        </Swiper>
      </section>

      {/* <!--Features One Start--> */}
      <section className="features-two">
        <div className="container">
          <div className="row">
            {/* <!--Start Single Features One--> */}
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft"
              data-wow-delay="0ms"
              data-wow-duration="1500ms"
            >
              <div className="features-two__single">
                <div className="features-two__single-top">
                  <div className="icon">
                    <span className="icon-information"></span>
                  </div>
                  <div className="count-box"></div>
                </div>
                <div className="features-two__single-title">
                  <h3>
                    <a href="#">Technology</a>
                  </h3>
                  <p>We’ve been using tech</p>
                </div>
              </div>
            </div>
            {/* <!--End Single Features One--> */}

            {/* <!--Start Single Features One--> */}
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="features-two__single">
                <div className="features-two__single-top">
                  <div className="icon">
                    <span className="icon-farmer"></span>
                  </div>
                  <div className="count-box"></div>
                </div>
                <div className="features-two__single-title">
                  <h3>
                    <a href="#">Best Farmers</a>
                  </h3>
                  <p>Skilled team of farmers</p>
                </div>
              </div>
            </div>
            {/* <!--End Single Features One--> */}

            {/* <!--Start Single Features One--> */}
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInRight"
              data-wow-delay="0ms"
              data-wow-duration="1500ms"
            >
              <div className="features-two__single">
                <div className="features-two__single-top">
                  <div className="icon">
                    <span className="icon-setting"></span>
                  </div>
                  <div className="count-box"></div>
                </div>
                <div className="features-two__single-title">
                  <h3>
                    <a href="#">We’re Certified</a>
                  </h3>
                  <p>Bharat Dhara is certified market</p>
                </div>
              </div>
            </div>
            {/* <!--End Single Features One--> */}

            {/* <!--Start Single Features One--> */}
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInRight"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="features-two__single">
                <div className="features-two__single-top">
                  <div className="icon">
                    <span className="icon-conveyor"></span>
                  </div>
                  <div className="count-box"></div>
                </div>
                <div className="features-two__single-title">
                  <h3>
                    <a href="#">We Deliver</a>
                  </h3>
                  <p>We’re delivering anywhere</p>
                </div>
              </div>
            </div>
            {/* <!--End Single Features One--> */}
          </div>
          <div
            className="features-two__call-box wow fadeInUp"
            data-wow-delay="0ms"
            data-wow-duration="1500ms"
          >
            <div className="row">
              <div className="col-xl-12">
                <div className="features-two__call-box-inner">
                  <div className="img-box">
                    <div className="icon">
                      <span className="icon-phone-call-2"></span>
                    </div>
                    <div className="inner">
                      <img src={`${callBoxImg}`} alt="" />
                    </div>
                  </div>
                  <div className="title">
                    <p>We Grow with love</p>
                    <h2>Our farmers grow best healthy products</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--Features One End--> */}

      {/* <!--About Two Start--> */}
      <section className="about-two">
        <div className="about-two__bg">
          <img src={`${AboutBackground}`} alt="" />
        </div>
        <div className="container">
          <div className="row">
            {/* <!--Start About Two Img Box--> */}
            <div className="col-xl-6 col-lg-6">
              <div className="about-two__img-box clearfix">
                <div className="about-two__img-box__shape"></div>
                {/* <!-- /.about-two__img-box__shape --> */}
                <div className="about-two__img-box-img1">
                  <div className="about-two__img-box-img1-inner">
                    <img src={`${AboutSectionImage}`} alt="" />
                  </div>
                </div>
                <div className="about-two__img-box-img2">
                  <div className="about-two__img-box-img2__shape"></div>
                  {/* <!-- /.about-two__img-box-img2__shape --> */}
                  <div className="logo">
                    <img src={`${AboutSectionLogo}`} alt="" />
                  </div>
                  <div className="about-two__img-box-img2-inner">
                    <img src={`${AboutSectionBoxImage}`} alt="" />
                  </div>
                </div>
              </div>
            </div>
            {/* <!--End About Two Img Box--> */}

            {/* <!--Start About Two Content Box--> */}
            <div className="col-xl-6 col-lg-6">
              <div className="about-two__content-box">
                <div className="sec-title">
                  <div className="icon">
                    <img src={`${AboutSecRightLogo}`} alt="" />
                  </div>
                  <span className="sec-title__tagline">
                    get to know about us
                  </span>
                  <h2 className="sec-title__title">
                    We’re Leader in Agriculture <br />
                    Market
                  </h2>
                </div>
                <p className="about-two__content-box-text">
                  There are many variations of passages of available but the
                  majority have suffered alteration in some form.
                </p>
                <div className="about-two__content-box-list">
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="about-two__content-box-list-single">
                        <ul>
                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Lorem is not random text</p>
                            </div>
                          </li>

                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Evolved over the years</p>
                            </div>
                          </li>

                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Generator on the Internet</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="about-two__content-box-list-single">
                        <ul>
                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>If you are going to use</p>
                            </div>
                          </li>

                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Making this the first true</p>
                            </div>
                          </li>

                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Over 50 years experience</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="about-two__progress">
                  {/* <!--Start Digital Factory One Progress Single--> */}
                  <div className="about-two__progress-single">
                    <h4 className="about-two__progress-title">Agriculture</h4>
                    <div className="bar">
                      <div className="bar-inner count-bar" data-percent="78%">
                        <div className="count-text">78%</div>
                      </div>
                    </div>
                  </div>
                  {/* <!--End Digital Factory One Progress Single--> */}

                  {/* <!--Start Digital Factory One Progress Single--> */}
                  <div className="about-two__progress-single">
                    <h4 className="about-two__progress-title">Organic</h4>
                    <div className="bar">
                      <div className="bar-inner count-bar" data-percent="67%">
                        <div className="count-text">67%</div>
                      </div>
                    </div>
                  </div>
                  {/* <!--End Digital Factory One Progress Single--> */}
                </div>

                <div className="about-two__author">
                  <h2>
                    Mike Hardson<span> CEO Bharat Dhara</span>
                  </h2>
                </div>
              </div>
            </div>
            {/* <!--End About Two Content Box--> */}
          </div>
        </div>
      </section>
      {/* <!--About Two End--> */}

      {/* <!--Services One Start--> */}
      <section className="services-one services-one--has-top-bg">
        <div className="container">
          <div className="sec-title text-center">
            <div className="icon">
              <img src={`${ServiceOneSecImage}`} alt="" />
            </div>
            <span className="sec-title__tagline">What we’re doing</span>
            <h2 className="sec-title__title">Services We Offer</h2>
          </div>
          <div className="row">
            {/* <!--Start Single Services One--> */}
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft"
              data-wow-delay="0ms"
              data-wow-duration="1000ms"
            >
              <div className="services-one__single">
                <div className="services-one__single-img">
                  <div className="services-one__single-img-inner">
                    <img src={`${firstServiceImage}`} alt="" />
                  </div>
                  <div className="services-one__single-img-icon">
                    <span className="icon-agriculture"></span>
                  </div>
                </div>
                <div className="services-one__single-content text-center">
                  <h3>
                    <a href="services-details.html">
                      Agriculture
                      <br />
                      Products
                    </a>
                  </h3>
                  <p>
                    Lorem ium dolor sit ametad pisicing elit sed simply do ut.
                  </p>
                  <a href="services-details.html" className="read-more-btn">
                    <span className="icon-right-arrow-2"></span>
                  </a>
                </div>
              </div>
            </div>
            {/* <!--End Single Services One--> */}

            {/* <!--Start Single Services One--> */}
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft"
              data-wow-delay="100ms"
              data-wow-duration="1000ms"
            >
              <div className="services-one__single">
                <div className="services-one__single-img">
                  <div className="services-one__single-img-inner">
                    <img src={`${secondServiceImage}`} alt="" />
                  </div>
                  <div className="services-one__single-img-icon">
                    <span className="icon-harvest"></span>
                  </div>
                </div>
                <div className="services-one__single-content text-center">
                  <h3>
                    <a href="services-details.html">
                      Fresh <br />
                      Vegetables
                    </a>
                  </h3>
                  <p>
                    Lorem ium dolor sit ametad pisicing elit sed simply do ut.
                  </p>
                  <a href="services-details.html" className="read-more-btn">
                    <span className="icon-right-arrow-2"></span>
                  </a>
                </div>
              </div>
            </div>
            {/* <!--End Single Services One--> */}

            {/* <!--Start Single Services One--> */}
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInRight"
              data-wow-delay="0ms"
              data-wow-duration="1000ms"
            >
              <div className="services-one__single">
                <div className="services-one__single-img">
                  <div className="services-one__single-img-inner">
                    <img src={`${thirdServiceImage}`} alt="" />
                  </div>
                  <div className="services-one__single-img-icon">
                    <span className="icon-growth"></span>
                  </div>
                </div>
                <div className="services-one__single-content text-center">
                  <h3>
                    <a href="services-details.html">
                      Oragnic <br />
                      Products
                    </a>
                  </h3>
                  <p>
                    Lorem ium dolor sit ametad pisicing elit sed simply do ut.
                  </p>
                  <a href="services-details.html" className="read-more-btn">
                    <span className="icon-right-arrow-2"></span>
                  </a>
                </div>
              </div>
            </div>
            {/* <!--End Single Services One--> */}

            {/* <!--Start Single Services One--> */}
            <div
              className="col-xl-3 col-lg-6 col-md-6 wow fadeInRight"
              data-wow-delay="100ms"
              data-wow-duration="1000ms"
            >
              <div className="services-one__single">
                <div className="services-one__single-img">
                  <div className="services-one__single-img-inner">
                    <img src={`${fourthServiceImage}`} alt="" />
                  </div>
                  <div className="services-one__single-img-icon">
                    <span className="icon-dairy-products"></span>
                  </div>
                </div>
                <div className="services-one__single-content text-center">
                  <h3>
                    <a href="services-details.html">
                      Dairy
                      <br />
                      Products
                    </a>
                  </h3>
                  <p>
                    Lorem ium dolor sit ametad pisicing elit sed simply do ut.
                  </p>
                  <a href="services-details.html" className="read-more-btn">
                    <span className="icon-right-arrow-2"></span>
                  </a>
                </div>
              </div>
            </div>
            {/* <!--End Single Services One--> */}
          </div>
        </div>
      </section>
      {/* <!--Services One End--> */}

      <section className="cta-two">
        <div className="cta-two__shape"></div>
        {/* <!-- /.cta-two__shape --> */}
        <div className="container">
          <div className="cta-two__inner">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <h2 className="cta-two__title">
                  Complete Agriculture Services
                </h2>
                {/* <!-- /.cta-two__title --> */}
              </div>
              {/* <!-- /.col-lg-6 --> */}
              <div className="col-lg-6">
                <div className="cta-two__right">
                  <ul className="cta-two__list list-unstyled">
                    <li>
                      <i className="fa fa-check-circle"></i>
                      Lorem is not random new text
                    </li>
                    <li>
                      <i className="fa fa-check-circle"></i>
                      Evolved over the 30 years
                    </li>
                  </ul>
                  {/* <!-- /.cta-two__list --> */}
                  <img src={`${SectionSeperatorImage}`} alt="" />
                </div>
                {/* <!-- /.cta-two__right --> */}
              </div>
              {/* <!-- /.col-lg-6 --> */}
            </div>
            {/* <!-- /.row --> */}
          </div>
          {/* <!-- /.cta-two__inner --> */}
        </div>
        {/* <!-- /.container --> */}
      </section>
      {/* <!-- /.cta-two --> */}

      <section className="features-three">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div className="features-three__image clearfix">
                <img src={`${ProjectSecLogo}`} alt="" />
                <div className="features-three__image__caption">
                  <i className="icon-growth"></i>
                  <h3>Agriculture Professional Leaders</h3>
                </div>
                {/* <!-- /.features-three__image__caption --> */}
              </div>
              {/* <!-- /.features-three__image --> */}
            </div>
            {/* <!-- /.col-xl-6 --> */}
            <div className="col-xl-6">
              <div className="features-three__content">
                <div className="sec-title text-left">
                  <div className="icon">
                    <img src={`${ProjectSecTitleIcon}`} alt="" />
                  </div>
                  <span className="sec-title__tagline">Company benefits</span>
                  <h2 className="sec-title__title">
                    Why Choose Bharat Dhara Market?
                  </h2>
                </div>
                <ul className="list-unstyled features-three__list">
                  <li>
                    <i className="fa fa-check"></i>
                    <div className="features-three__list__content">
                      <h3>Quality Organic Food</h3>
                      <p>
                        Solution for small and large businesses volup
                        accusantium doloremque laudantium.
                      </p>
                    </div>
                    {/* <!-- /.features-three__list__content --> */}
                  </li>
                  <li>
                    <i className="fa fa-check"></i>
                    <div className="features-three__list__content">
                      <h3>100% Satisfaction</h3>
                      <p>
                        Solution for small and large businesses volup
                        accusantium doloremque laudantium.
                      </p>
                    </div>
                    {/* <!-- /.features-three__list__content --> */}
                  </li>
                  <li>
                    <i className="fa fa-check"></i>
                    <div className="features-three__list__content">
                      <h3>Professional Staff</h3>
                      <p>
                        Solution for small and large businesses volup
                        accusantium doloremque laudantium.
                      </p>
                    </div>
                    {/* <!-- /.features-three__list__content --> */}
                  </li>
                </ul>
                {/* <!-- /.list-unstyle --> */}
              </div>
              {/* <!-- /.features-three__content --> */}
            </div>
            {/* <!-- /.col-xl-6 --> */}
          </div>
          {/* <!-- /.row --> */}
        </div>
        {/* <!-- /.container --> */}
      </section>
      {/* <!-- /.features-three --> */}

      {/* HOW CAN WE HELP || FAQ */}
      {/* <!--Faq One Start--> */}
      <section className="faq-one faq-one__dark">
        <div className="faq-one__shape"></div>
        {/* <!-- /.faq-one__shape --> */}
        <div className="container">
          <div className="row">
            {/* <!--Start Faq One Content--> */}
            <div className="col-xl-6 col-lg-6">
              <div className="faq-one__content">
                <div className="sec-title">
                  <div className="icon">
                    <img src={`${FaqIconContent}`} alt="" />
                  </div>
                  <span className="sec-title__tagline">
                    Recently completed work
                  </span>
                  <h2 className="sec-title__title">How Can We Help?</h2>
                </div>
                <div className="faq-one__inner-content">
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="faq-one__inner-content-left">
                        <img src={`${FaqImage}`} alt="" />
                        <p>
                          Voluptate velit essect quis
                          <br />
                          tempor orci. Suspendisse
                          <br />
                          that potenti faucibus.
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="faq-one__inner-content-list">
                        <ul>
                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Refresing to get such touch</p>
                            </div>
                          </li>

                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Duis aute irure dolor in</p>
                            </div>
                          </li>

                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Reprehenderit in voluptate</p>
                            </div>
                          </li>

                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Velit esse cillum dolore eu</p>
                            </div>
                          </li>

                          <li>
                            <div className="icon">
                              <i
                                className="fa fa-check-circle"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <div className="text">
                              <p>Fugiat nulla pariatur</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="faq-one__btn">
                  <a href="#" className="thm-btn">
                    learn more
                  </a>
                </div>
              </div>
            </div>
            {/* <!--End Faq One Content--> */}

            {/* <!--Start Faq One Accordions--> */}
            <div className="col-xl-6 col-lg-6">
              <div className="faq-one__accordions">
                <div
                  className="accrodion-grp"
                  data-grp-name="faq-one-accrodion"
                >
                  {/* <!--Start Faq One Single--> */}
                  <div
                    className="accrodion active wow fadeInUp"
                    data-wow-delay="0ms"
                    data-wow-duration="1000ms"
                    onClick={changeActiveFaq}
                  >
                    <div className="accrodion-title">
                      <h4>Company Provides a Full Range of Services?</h4>
                    </div>
                    <div className="accrodion-content">
                      <div className="inner">
                        <p>
                          Suspendisse finibus urna mauris, vitae consequat quam
                          vel. Vestibulum leo ligula, vitae commodo nisl. Lorem
                          ipsum is simply free text available in the market
                          adipisi cing elit.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- End Faq One Single--> */}

                  {/* <!--Start Faq One Single--> */}
                  <div
                    className="accrodion wow fadeInUp"
                    data-wow-delay="100ms"
                    data-wow-duration="1000ms"
                    onClick={changeActiveFaq}
                  >
                    <div className="accrodion-title">
                      <h4>Home Improvement Works are Expensive?</h4>
                    </div>
                    <div className="accrodion-content">
                      <div className="inner">
                        <p>
                          Suspendisse finibus urna mauris, vitae consequat quam
                          vel. Vestibulum leo ligula, vitae commodo nisl. Lorem
                          ipsum is simply free text available in the market
                          adipisi cing elit.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- End Faq One Single--> */}

                  {/* <!--Start Faq One Single--> */}
                  <div
                    className="accrodion wow fadeInUp"
                    data-wow-delay="200ms"
                    data-wow-duration="1000ms"
                    onClick={changeActiveFaq}
                  >
                    <div className="accrodion-title">
                      <h4>Home Improvement Works are Expensive?</h4>
                    </div>
                    <div className="accrodion-content">
                      <div className="inner">
                        <p>
                          Suspendisse finibus urna mauris, vitae consequat quam
                          vel. Vestibulum leo ligula, vitae commodo nisl. Lorem
                          ipsum is simply free text available in the market
                          adipisi cing elit.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- End Faq One Single--> */}

                  {/* <!--Start Faq One Single--> */}
                  <div
                    className="accrodion wow fadeInUp"
                    data-wow-delay="300ms"
                    data-wow-duration="1000ms"
                    onClick={changeActiveFaq}
                  >
                    <div className="accrodion-title">
                      <h4>Home Improvement Works are Expensive?</h4>
                    </div>
                    <div className="accrodion-content">
                      <div className="inner">
                        <p>
                          Suspendisse finibus urna mauris, vitae consequat quam
                          vel. Vestibulum leo ligula, vitae commodo nisl. Lorem
                          ipsum is simply free text available in the market
                          adipisi cing elit.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <!-- End Faq One Single--> */}
                </div>
              </div>
            </div>
            {/* <!--End Faq One Accordions--> */}
          </div>
        </div>
      </section>
      {/* <!--Faq One End--> */}

      {/* <!--Projects One Start--> */}
      <section className="projects-one projects-one--two">
        <div className="container">
          <div className="sec-title text-center">
            <div className="icon">
              <img src={`${ProjectSecIcon}`} alt="" />
            </div>
            <span className="sec-title__tagline">Recently completed work</span>
            <h2 className="sec-title__title">Explore Our Projects</h2>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="projects-two__carousel owl-carousel owl-theme owl-dot-type1">
                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img src={`${firstProjectImage}`} alt="" />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}

                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img src={`${secondProjectImage}`} alt="" />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}

                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="400ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img src={`${thirdProjectImage}`} alt="" />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}

                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img src={`${fourProjectImage}`} alt="" />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}

                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img
                      src="assets/images/project/projects-v2-img2.jpg"
                      alt=""
                    />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}

                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="400ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img
                      src="assets/images/project/projects-v2-img3.jpg"
                      alt=""
                    />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}

                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="0ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img
                      src="assets/images/project/projects-v2-img1.jpg"
                      alt=""
                    />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}

                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img src={`${ProjectOneImage}`} alt="" />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}

                {/* <!--Start Single Projects One--> */}
                <div
                  className="projects-one__single wow fadeInUp"
                  data-wow-delay="400ms"
                  data-wow-duration="1500ms"
                >
                  <div className="projects-one__single-img">
                    <img src={`${ProjectTwoImage}`} alt="" />
                    <div className="overlay-content">
                      <p>Agriculture</p>
                      <h3>
                        <a href="projects-details.html">Harvest Innovations</a>
                      </h3>
                    </div>
                  </div>
                </div>
                {/* <!--End Single Projects One--> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--Projects One End--> */}

      {/* <!--Story One Start--> */}
      <section className="story-one">
        <div className="story-one__shape"></div>
        {/* <!-- /.story-one__shape --> */}
        <div className="auto-container">
          <div className="row">
            <div className="col-xl-6">
              <div
                className="story-one__img"
                style={{
                  backgroundImage: `url(${StorySectionOne})`,
                }}
              >
                <div className="story-one__img__line float-bob-y"></div>
                {/* <!-- /.story-one__img__line --> */}
                <h3>
                  #Agriculture <br />
                  Matters
                </h3>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="story-one__counters">
                <div className="story-one__bg">
                  <img src={`${StorySectionTwo}`} alt="" />
                </div>
                <div className="sec-title">
                  <div className="icon">
                    <img src={`${StorySectionIcon}`} alt="" />
                  </div>
                  <span className="sec-title__tagline">
                    Bharat Dhara Since 1986
                  </span>
                  <h2 className="sec-title__title">Small Agricultue Story</h2>
                </div>
                <p className="story-one__counters-text">
                  We are committed to providing our customers with exceptional
                  service while offering our employees the best training.
                </p>

                <div className="story-one__counters-box">
                  <ul>
                    {/* <!--Start Single Story One Counters Box--> */}
                    <li
                      className="story-one__counters-box-single text-center wow slideInUp animated"
                      data-wow-delay="0.1s"
                      data-wow-duration="1500ms"
                    >
                      <h3 className="odometer" data-count="869">
                        00
                      </h3>
                      <p className="story-one__counters-box-single-text">
                        Projects <br />
                        Completed
                      </p>
                    </li>
                    {/* <!--End Single Story One Counters Box--> */}

                    {/* <!--Start Single Story One Counters Box--> */}
                    <li
                      className="story-one__counters-box-single text-center wow slideInUp animated"
                      data-wow-delay="0.3s"
                      data-wow-duration="1500ms"
                    >
                      <h3 className="odometer" data-count="683">
                        00
                      </h3>
                      <p className="story-one__counters-box-single-text">
                        Satisfied <br />
                        Customers
                      </p>
                    </li>
                    {/* <!--End Single Story One Counters Box--> */}

                    {/* <!--Start Single Story One Counters Box--> */}
                    <li
                      className="story-one__counters-box-single text-center wow slideInUp animated"
                      data-wow-delay="0.5s"
                      data-wow-duration="1500ms"
                    >
                      <h3 className="odometer" data-count="975">
                        00
                      </h3>
                      <p className="story-one__counters-box-single-text">
                        Organic <br />
                        Products
                      </p>
                    </li>
                    {/* <!--End Single Story One Counters Box--> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--Story One End--> */}
    </>
  );
}

export default Home;
